'use client'

import { useState, type FormEvent } from 'react'
import { ArrowRight, MailCheck } from 'lucide-react'

export default function MagicForm({ returnUrl }: { returnUrl?: string }) {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!email.trim()) return
    setStatus('sending')
    try {
      const res = await fetch('/api/auth/magic/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), returnUrl }),
      })
      if (!res.ok) throw new Error('falha')
      setStatus('sent')
    } catch {
      setStatus('error')
    }
  }

  if (status === 'sent') {
    return (
      <div className="text-center">
        <div
          className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl shadow-lg"
          style={{ background: 'var(--brand-primary, var(--brand-grad))' }}
        >
          <MailCheck className="h-7 w-7 text-white" />
        </div>
        <h2 className="font-display text-lg font-semibold text-ink-0">Feito. Confira seu e-mail.</h2>
        <p className="mt-2 text-sm leading-relaxed text-ink-4">
          Mandamos o acesso para <strong className="font-semibold text-ink-2">{email}</strong>.
          Clique no botão do e-mail pra entrar. Vale por 15 minutos.
        </p>
        <p className="mt-3 text-xs text-ink-5">
          Não chegou? Dá uma olhada no spam, ou tente de novo em alguns minutos.
        </p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3.5">
      <div>
        <label
          htmlFor="email"
          className="mb-1.5 block font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-ink-4"
        >
          Seu e-mail
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-xl border border-ink-6 bg-white px-4 py-3 text-[15px] text-ink-1 placeholder:text-ink-5 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary,#ef3476)]"
          placeholder="voce@email.com"
        />
      </div>

      {status === 'error' && (
        <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          Não deu certo dessa vez. Tenta de novo em instantes.
        </div>
      )}

      <button
        type="submit"
        disabled={status === 'sending'}
        className="group flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-[15px] font-semibold text-white shadow-lg transition-all hover:brightness-95 disabled:opacity-60"
        style={{ background: 'var(--brand-primary, var(--brand-grad))' }}
      >
        {status === 'sending' ? (
          'Enviando…'
        ) : (
          <>
            Enviar meu acesso
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </>
        )}
      </button>

      <p className="text-center text-xs leading-relaxed text-ink-5">
        Conta nova ou existente, a porta é a mesma. Sem senha pra decorar.
      </p>
    </form>
  )
}
